module.exports = __webpack_public_path__ + "img/商机.86fe7d6b.svg";